import React from 'react';
import type { CSS } from '@components-shared/src/stitches';
import { styled } from '@components-shared/src/stitches';

// Place inside a container with position relative for the blur and overlay to cover the background as expected
export const BackgroundBlur = () => (
  <>
    <Blur />
    <Overlay />
  </>
);

const sharedStyles: CSS = {
  position: 'absolute',
  height: '100%',
  width: '100%',
  top: 0,
  left: 0,
};

const Blur = styled('div', {
  ...sharedStyles,
  backgroundColor: ' rgba(255, 255, 255, 0.01)',
  backdropFilter: 'blur(32px)',
  transform: 'translate3d(0,0,0)',
});

const Overlay = styled('div', {
  ...sharedStyles,
  opacity: 0.5,
  backgroundColor: '$black',
});
